<template>
  <div class="forget">
    <LoginBg :title="title">
      <div class="forget-content">
        <div class="forget-form">
          <div class="title">{{ title }}</div>
          <div v-if="stepNum === 1">
            <el-form :rules="dataRule" ref="fastDataForm" :model="fastDataForm">
              <el-form-item :label="$t('forget.email')" prop="fastPhone">
                <el-input
                  v-model="fastDataForm.fastPhone"
                  maxlength="20"
                  :placeholder="$t('forget.emailPlaceholder')"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('forget.captcha')" prop="imgfastCaptcha">
                <div class="relative">
                  <el-input
                    v-model="fastDataForm.imgfastCaptcha"
                    :placeholder="$t('login.captchaPlaceholder')"
                    maxlength="20"
                  ></el-input>
                  <img
                    class="captchaImg"
                    @click="getCaptcha"
                    :src="captchaPath"
                    :disabled="disabled"
                  />
                </div>
              </el-form-item>
              <el-form-item
                :label="$t('forget.verificationCode')"
                prop="fastCaptcha"
              >
                <div class="relative">
                  <el-input
                    v-model="fastDataForm.fastCaptcha"
                    :placeholder="$t('login.captchaPlaceholder')"
                    maxlength="20"
                  ></el-input>
                  <el-button
                    class="codeBtn"
                    @click="sendcode"
                    :disabled="disabled"
                    type="text"
                    >{{ btntxt }}</el-button
                  >
                </div>
              </el-form-item>
            </el-form>
            <div class="btn-box">
              <el-button class="nextBtn" type="primary" @click="next">{{
                $t("forget.continue")
              }}</el-button>
            </div>
          </div>
          <div v-if="stepNum === 2">
            <el-form :model="dataForm" :rules="editDataRule" ref="dataForm">
              <el-form-item :label="$t('forget.password')" prop="password">
                <el-input
                  v-model="dataForm.password"
                  type="password"
                  maxlength="20"
                  auto-complete="new-password"
                  :placeholder="$t('forget.passwordPlaceholder')"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('forget.passwordAgain')"
                prop="rePassword"
              >
                <el-input
                  v-model="dataForm.rePassword"
                  type="password"
                  maxlength="20"
                  auto-complete="new-password"
                  :placeholder="$t('forget.passwordAgainPlaceholder')"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="btn-box">
              <el-button class="nextBtn" type="primary" @click="save">{{
                $t("confirm")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </LoginBg>
  </div>
</template>

<script>
import LoginBg from './components/bg.vue'
import { getUUID } from '@/utils'
import { Base64 } from 'js-base64'

export default {
  components: {
    LoginBg
  },
  data () {
    return {
      stepNum: 1,
      fastDataForm: {
        fastPhone: '',
        fastCaptcha: '',
        imgfastCaptcha: ''
      },
      dataForm: {
        rePassword: '',
        password: '',
        uuid: ''
      },
      captchaPath: '',
      title: this.$t('forget.title'),
      disabled: false,
      btntxt: this.$t('login.captchaGet')
    }
  },
  computed: {
    dataRule () {
      return {
        fastPhone: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        fastCaptcha: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ],
        imgfastCaptcha: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          }
        ]
      }
    },
    editDataRule () {
      let validatePassword = (rule, value, callback) => {
        if (value && value !== this.dataForm.password) {
          return callback(new Error(this.$t('forget.validatePassword')))
        }
        callback()
      }
      var validatePassword2 = (rule, value, callback) => {
        var myreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,30}$/
        if (!myreg.test(value)) {
          callback(new Error(this.$t('forget.validatePassword2')))
        } else {
          callback()
        }
      }
      return {
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { required: true, validator: validatePassword2, trigger: 'blur' }
        ],
        rePassword: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur'
          },
          { validator: validatePassword, trigger: 'blur' },
          { required: true, validator: validatePassword2, trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.type === 'modify') {
      this.title = this.$t('forget.title2')
    } else {
      this.title = this.$t('forget.title')
    }
    this.getCaptcha()
    // console.log(this.$router)
  },
  methods: {
    // 保存
    save () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http
          .post('/front/consumer/user/resetPassword', {
            mobile: this.fastDataForm.fastPhone,
            password: Base64.encode(this.dataForm.password),
            messageCode: this.fastDataForm.fastCaptcha,
            requestId: this.fastDataForm.requestId
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success'
              })
              this.$router.push({
                name: 'login'
              })
            }
          })
          .catch(() => {})
      })
    },
    // 下一步
    next () {
      this.$refs['fastDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http
          .get(
            `/front/consumer/checkMessageCode?mobile=${this.fastDataForm.fastPhone}&requestId=${this.fastDataForm.requestId}&messageCode=${this.fastDataForm.fastCaptcha}`
          )
          .then((res) => {
            if (res.data.code === 0) {
              this.stepNum = 2
            }
          })
          .catch(() => {})
      })
    },
    // 获取验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/front/consumer/sysCaptcha/${this.dataForm.uuid}`
    },
    // 手机验证发送验证码
    sendcode () {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
      if (this.fastDataForm.fastPhone === '') {
        this.$message({
          message: '请先输入手机号码',
          type: 'warning'
        })
        return
      }
      if (!reg.test(this.fastDataForm.fastPhone)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning'
        })
        return false
      } else if (!this.fastDataForm.imgfastCaptcha) {
        this.$message({
          message: this.$t('forget.captchaPlaceholder'),
          type: 'warning'
        })
      } else {
        this.fastDataForm.requestId = ''
        this.disabled = true
        // 快捷登录发送验证码
        this.$http
          .get(
            `front/consumer/user/forgetPassword?mobile=${this.fastDataForm.fastPhone}&uuid=${this.dataForm.uuid}&captcha=${this.fastDataForm.imgfastCaptcha}`
          )
          .then((res) => {
            if (res.data.code === 0) {
              this.fastDataForm.requestId = res.data.data.requestId
              this.time = 60
              this.timer()
            } else {
              this.getCaptcha()
              this.disabled = false
            }
          })
          .catch(() => {
            this.disabled = false
          })
      }
    },
    // 60S倒计时
    timer () {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's' + this.$t('login.captchaGetAgain')
        this.$nextTick(() => {
          setTimeout(this.timer, 1000)
        })
      } else {
        this.time = 0
        this.btntxt = this.$t('login.captchaGet')
        this.disabled = false
        this.getCaptcha()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.forget {
  font-family: AlibabaPuHuiTi;
  .forget-content {
    width: 100%;
    height: 540px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .forget-form {
    padding: 20px;
    border-radius: 16px;
    background-color: #fff;
    width: 540px;
  }
  .title {
    font-size: 28px;
    color: #3d3d3d;
  }
  .relative {
    position: relative;
  }
  .codeBtn {
    position: absolute;
    top: 46px;
    right: 28px;
  }
  .captchaImg {
    width: 100px;
    height: 30px;
    position: absolute;
    top: 50px;
    right: 12px;
  }
  .btn-box {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .nextBtn {
    width: 162px;
    height: 43px;
    border-radius: 8px;
    background-color: #2a54d1;
    border-color: #2a54d1;
    box-shadow: 0px 4px 10px 0px rgba(116, 183, 255, 0.3);
  }

  ::v-deep .el-input__inner {
    height: 52px;
    line-height: 52px;
  }
  ::v-deep .el-input__inner:focus {
    border-color: #2a54d1;
  }
  ::v-deep .el-button--text {
    color: #2a54d1;
  }
}
</style>
